import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getUnitById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateUnit } from "..";

const EditUnit = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getUnit();
        else setLoading(false);
    }, [id]);

    const getUnit = async () => {
        try {
            const { data } = await getUnitById(id);
            setItem(data.unit);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateUnit from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_category' />
};

export default EditUnit;